export default __webpack_public_path__ + "static/media/requiere_nota_sencilla.fb55e38d.svg";